import { Autocomplete, debounce, TextField } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { url } from 'src/Helpers/utils/Constant';
import { IuserMemberList } from 'src/Types/module/invoice/invoiceTypes';

const CommonMultipleSelectMembers = ({
  onChange,
  defaultData,
  label,
  size,
  onAddValue,
  onRemoveValue,
}: {
  size?: 'small' | 'medium';
  label?: string;
  onChange: (number: number[]) => void;
  defaultData?: {
    user_member_id: number;
    user_member_company_name: string;
  }[];
  onRemoveValue?: (number: number[]) => void;
  onAddValue?: (number: number[]) => void;
}) => {
  const [allMember, setAllMember] = useState<IuserMemberList[] | any>([]);
  const [companyName, seTCompanyName] = useState<string>('');
  useEffect(() => {
    (async function () {
      try {
        const { data } = await axios.get(
          `${url}/api/atab/user-member/company-name/get-all/status-or-all/all?company_name=${encodeURIComponent(companyName)}`
        );
        if (data.success) {
          setAllMember(data.data);
        }
      } catch (error) {}
    })();
  }, [companyName]);

  const handelInputChange = debounce((value: string) => {
    seTCompanyName(value);
  }, 500);
  return (
    <Autocomplete
      defaultValue={defaultData || []}
      size={size || 'small'}
      multiple
      isOptionEqualToValue={(option, value) =>
        option.user_member_company_name === value.user_member_company_name
      }
      onInputChange={(_event, newInputValue) => {
        handelInputChange(newInputValue);
      }}
      getOptionLabel={(option) => option.user_member_company_name}
      options={allMember}
      onChange={(_event, newValue) => {
        if (newValue && newValue?.length) {
          const memberIds = newValue?.map((member) => member.user_member_id);
          onChange && onChange(memberIds);

          // if addNewValue or removeExisValue---------when updating----------
          if (defaultData && defaultData?.length) {
            const defaultValueIds = defaultData?.map(
              (member) => member.user_member_id
            );
            const removeValue = defaultValueIds?.filter(
              (value) => !memberIds.includes(value)
            );
            const addedValue = memberIds.filter(
              (value) => !defaultValueIds.includes(value)
            );
            onAddValue && onAddValue(addedValue);
            onRemoveValue && onRemoveValue(removeValue);
          }
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label || 'Select Member'} />
      )}
    />
  );
};

export default CommonMultipleSelectMembers;
